import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useKraCycleStore from '../../store/kraCycleStore';
import useAuthStore from '../../store/authStore';

const STATUS_LABELS = {
  draft: 'Draft',
  self_submitted: 'Submitted — Awaiting External Input',
  external_pending: 'Submitted — Awaiting External Input',
  ready_for_hod: 'Submitted — Awaiting HOD Review',
  locked: 'Reviewed',
  reopened: 'Reopened for Correction',
};

const StatusPill = ({ status }) => {
  const tone = status === 'locked' ? 'bg-green-100 text-green-800'
    : status === 'draft' ? 'bg-amber-100 text-amber-800'
    : status === 'reopened' ? 'bg-red-100 text-red-800'
    : 'bg-gray-200 text-gray-700';
  return <span className={`text-xs font-semibold px-2 py-1 rounded ${tone}`}>{STATUS_LABELS[status] || status}</span>;
};

const MyKRAPage = () => {
  const { user } = useAuthStore();
  const { cycles, isLoading, fetchCycles } = useKraCycleStore();

  useEffect(() => {
    if (user?.id) fetchCycles({ employee_id: user.id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-white mb-6">My KRA</h1>

        {isLoading || !user?.id ? (
          <p className="text-gray-500">Loading...</p>
        ) : cycles.length === 0 ? (
          <div className="glass-card p-6 text-sm text-gray-500">
            No KRA record yet for you. Your HOD or HR generates a new cycle at the start of each month —
            check back once one appears here.
          </div>
        ) : (
          <div className="glass-card divide-y divide-gray-100">
            {cycles.map((c) => (
              <Link
                key={c.id}
                to={`/kra/${c.id}`}
                className="flex items-center justify-between px-5 py-4 hover:bg-gray-50"
              >
                <div>
                  <div className="font-semibold text-gray-900">
                    {new Date(c.month).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5">
                    {c.final_score !== null ? `Final Score: ${c.final_score}/100` : 'Not yet finalized'}
                  </div>
                </div>
                <StatusPill status={c.status} />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyKRAPage;
